// extracted by mini-css-extract-plugin
module.exports = {"container":"of","slide":"oh","show":"oi"};